import { render, staticRenderFns } from "./ReportView.vue?vue&type=template&id=4c361b36"
import script from "./ReportView.vue?vue&type=script&lang=js"
export * from "./ReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports